import { apiClient } from "./api";
import { isAxiosError } from "axios";

class AuthService {
  private basicURL: string;
  private generalURL: string;

  constructor() {
    this.basicURL = "/Auth";
    this.generalURL = "/General";
  }

  async login(username: string, password: string) {
    const endpoint = `${this.basicURL}/Login`;
    const body = JSON.stringify({
      username: username,
      password: password,
    });
    try {
      const response = await apiClient.post(endpoint, body);
      return response.data;
    } catch (error: unknown) {
      if (error instanceof Error) {
        console.error(error.message);
        return "invalid";
      } else {
        console.error("Unknown error occurred");
        return "invalid";
      }
    }
  }

  async getUsuarioNivelFacturador(token: string) {
    const endpoint = `${this.basicURL}/GetUsuarioNivelFacturador`;
    try {
      const response = await apiClient.get(endpoint);
      return response.data;
    } catch (error: unknown) {
      if (error instanceof Error) {
        console.error(error.message);
        return false;
      } else {
        console.error("Unknown error occurred");
        return false;
      }
    }
  }

  async cambiarPassword(password: string) {
    const endpoint = `${this.basicURL}/ChangePassword`;
    const body = JSON.stringify({
      password: password,
    });
    try {
      const response = await apiClient.post(endpoint, body);
      return response;
    } catch (error: unknown) {
      if (error instanceof Error) {
        console.error(error.message);
        return error
      } else {
        console.error("Unknown error occurred");
        return error
      }
    }
  }
  
  async resetPassword(username: string){
    const endpoint = `${this.basicURL}/ResetPassword`;
    const body = JSON.stringify({
      username: username,
    });
    try {
      const response = await apiClient.post(endpoint, body);
      return response;
    } catch (error: unknown) {
      if (error instanceof Error) {
        console.error(error.message);
        return error
      } else {
        console.error("Unknown error occurred");
        return error
      }
    }
  }

  async register(username: string, email: string, rol: number){
    const endpoint = `${this.basicURL}/Register`;
    const body = JSON.stringify({
      username: username,
      email: email,
      rol: rol,
    });
    try {
      const response = await apiClient.post(endpoint, body);
      return response;
    } catch (error: unknown) {
      if (error instanceof Error) {
        console.error(error.message);
        return error
      } else {
        console.error("Unknown error occurred");
        return error
      }
    }
  }

  async crearUsuNivFact(idUsuario: string, idFacturador: string){
    const endpoint = `${this.generalURL}/AgregarUsuarioNivelFacturador`;
    const body = JSON.stringify({
      idUsuario: idUsuario,
      idNivel: "61ba8cc1-978f-4147-a68a-8f4cb530bd81", //id nivel 1 hardcodeado
      idFacturador: idFacturador,
    });
    try {
      const response = await apiClient.post(endpoint, body);
      return response;
    } catch (error: unknown) {
      if (error instanceof Error) {
        console.error(error.message);
        return error
      } else {
        console.error("Unknown error occurred");
        return error
      }
    }
  }

  async eliminarUsuNivFact(idUsuario: string, idFacturador: string){
    const endpoint = `${this.generalURL}/DeshabilitarUsuarioNivelFacturador`;
    const body = JSON.stringify({
      idUsuario: idUsuario,
      idNivel: "61ba8cc1-978f-4147-a68a-8f4cb530bd81", //id nivel 1 hardcodeado
      idFacturador: idFacturador,
    });
    try {
      const response = await apiClient.post(endpoint, body);
      return response;
    } catch (error: unknown) {
      if (error instanceof Error) {
        console.error(error.message);
        return error
      } else {
        console.error("Unknown error occurred");
        return error
      }
    }
  }

  async getRoles(){
    const endpoint = `${this.basicURL}/GetRoles`;
    try {
      const response = await apiClient.get(endpoint);
      return response.data;
    } catch (error: unknown) {
      if (error instanceof Error) {
        console.error(error.message);
        return false;
      } else {
        console.error("Unknown error occurred");
        return false;
      }
    }
  }

  async buscarUsuario(username: string){
    const endpoint = `${this.basicURL}/GetUsuario`;
    const body = JSON.stringify({
      username: username,
    });
    try {
      const response = await apiClient.post(endpoint, body);
      return response;
    } catch (error: unknown) {
      if (isAxiosError(error)) {
        return error.response;
      }
      return "Error al buscar el usuario";
    }
  }

  async getOSAuditor(idUsuario: string){
    const endpoint = `${this.basicURL}/GetObrasSocialesAuditor`;
    const body = JSON.stringify({
      idUsuario: idUsuario,
    });
    try {
      const response = await apiClient.post(endpoint, body);
      return response;
    }
    catch (error: unknown) {
      if (isAxiosError(error)) {
        return error.response;
      }
      return "Error al buscar las obras sociales del auditor";
    }
  }

  async vincularOSAuditor(idUsuario: string, idOS: string){
    const endpoint = `${this.basicURL}/VincularAuditorObraSocial`;
    const body = JSON.stringify({
      idUsuario: idUsuario,
      idObraSocial: idOS,
    });
    try {
      const response = await apiClient.post(endpoint, body);
      return response;
    } catch (error: unknown) {
      if (isAxiosError(error)) {
        return error.response;
      }
      return "Error al vincular la obra social al auditor";
    }
  }

  async vincularBandejaAutorizador(idUsuario: string, idBandeja: string){
    const endpoint = `${this.basicURL}/VincularAutorizadorBandeja`;
    const body = JSON.stringify({
      idUsuario: idUsuario,
      idBandejaAutorizacion: idBandeja,
    });
    try {
      const response = await apiClient.post(endpoint, body);
      return response;
    } catch (error: unknown) {
      if (isAxiosError(error)) {
        return error.response;
      }
      return "Error al vincular la bandeja al autorizador";
    }
  }

  async getUsuariosPorRoles(rolesUsuarios: number[]){
    const endpoint = `${this.basicURL}/GetUsuariosPorRoles`;
    const body = JSON.stringify({
      roles: rolesUsuarios,
    });
    try {
      const response = await apiClient.post(endpoint, body);
      return response;
    } catch (error: unknown) {
      if (isAxiosError(error)) {
        return error.response;
      }
      return "Error al obtener los usuarios por tipo";
    }
  }

}

export default AuthService;
